import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import "@/App.css";
import AppShell from "./layouts/AppShell";
import WalletHome from "./pages/WalletHome";
import Withdraw from "./pages/Withdraw";
import PayoutTracker from "./pages/PayoutTracker";
import Activity from "./pages/Activity";
import Payouts from "./pages/Payouts";
import Admin from "./pages/Admin";
import AdminPayouts from "./pages/AdminPayouts";
import AdminFinance from "./pages/AdminFinance";
import { UserProvider, useUser } from "./context/UserContext";

function Boot({ children }) {
  const { loading, activeUser } = useUser();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500 text-sm">
        Loading Pay10x sandbox…
      </div>
    );
  if (!activeUser)
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500 text-sm">
        No demo users found.
      </div>
    );
  return children;
}

function AdminGate({ children }) {
  const { isAdmin } = useUser();
  const loc = useLocation();
  if (!isAdmin) return <Navigate to="/" replace state={{ from: loc.pathname }} />;
  return children;
}

function CustomerGate({ children }) {
  const { isAdmin } = useUser();
  if (isAdmin) return <Navigate to="/admin" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <UserProvider>
        <BrowserRouter>
          <Boot>
            <Routes>
              <Route element={<AppShell />}>
                <Route index element={<CustomerGate><WalletHome /></CustomerGate>} />
                <Route path="/withdraw" element={<CustomerGate><Withdraw /></CustomerGate>} />
                <Route path="/payouts" element={<CustomerGate><Payouts /></CustomerGate>} />
                <Route path="/payouts/:id" element={<PayoutTracker />} />
                <Route path="/activity" element={<CustomerGate><Activity /></CustomerGate>} />
                <Route path="/admin" element={<AdminGate><Admin /></AdminGate>} />
                <Route path="/admin/payouts" element={<AdminGate><AdminPayouts /></AdminGate>} />
                <Route path="/admin/finance" element={<AdminGate><AdminFinance /></AdminGate>} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Route>
            </Routes>
          </Boot>
        </BrowserRouter>
      </UserProvider>
    </div>
  );
}

export default App;
